const hostingPlans = [
  {
    price: "999",
    features: [
      "One No-code website/Landing Page templates",
      "One Custom domain integration",
      "1GB Memory, 1vCPU, 1TB Transfer, 25GB SSD",
      "Secure your platform with SSL certificates",
      "One Lead Center",
      "Admin Only",
      "Keep track of your Leads/Sales with real-time reporting",
      "Power up your workflows with integrations including Zoom, Facebook pixel, Google Analytics, Heat Map tools, Search Console, Google Tag Manager, Mailchimp, API access and more",
      "Send WhatsApp/Email Message from CRM",
      "Keypad dialer for Calls",
      "Live Chat Bot/WhatsApp Button integrations",
      "Live chat and email support"
    ]
  },
  {
    price: "2,499",
    features: [
      "Upto 3 No-code website/Landing Page templates",
      "Upto 3 Custom domain integration",
      "2GB Memory, 1vCPU, 2TB Transfer, 50GB SSD",
      "Secure your platform with SSL certificates",
      "Upto 3 Lead Center",
      "Admin + One Team Role",
      "Keep track of your Leads/Sales with real-time reporting",
      "Gather deep insights into your marketing with conversion tracking",
      "Collect payments with Razorpay, Stripe or a gateway that suits you",
      "Power up your workflows with integrations including Zoom, Facebook pixel, Google Analytics, Heat Map tools, Search Console, Google Tag Manager, Mailchimp, API access and more",
      "Send WhatsApp/Email Message from CRM",
      "Keypad dialer for Calls",
      "Live Chat Bot/WhatsApp Button integrations",
      "Option to remove KeywordsFly branding from your LandingPage/Website",
      "Live chat and email support"
    ]
  },
  {
    price: "3,999",
    features: [
      "Upto 5 No-code website/Landing Page templates",
      "Upto 5 Custom domain integration",
      "5GB Memory, 1vCPU, 5TB Transfer, 100GB SSD",
      "Secure your platform with SSL certificates",
      "Upto 5 Lead Center",
      "Admin + Upto 5 Roles",
      "Keep track of your Leads/Sales with real-time reporting",
      "Gather deep insights into your marketing with conversion tracking",
      "Collect payments with Razorpay, Stripe or a gateway that suits you",
      "Power up your workflows with integrations including Zoom, Facebook pixel, Google Analytics, Heat Map tools, Search Console, Google Tag Manager, Mailchimp, API access and more",
      "Send WhatsApp/Email Message from CRM",
      "Keypad dialer for Calls",
      "Live Chat Bot/WhatsApp Button integrations",
      "Option to remove KeywordsFly branding from your LandingPage/Website",
      "Live chat and email support"
    ]
  }
];

export default hostingPlans;
